module.exports = __webpack_public_path__ + "img/resources-stall-2.6bda7912.jpg";